import { Link } from 'react-router-dom';

interface ArticleCardProps {
  id: number;
  title: string;
  category: string;
  categoryName: string;
  author: string;
  authorAvatar: string;
  cover: string;
  excerpt: string;
  tags: string[];
  createdAt: string;
  readCount: number;
  likeCount: number;
  commentCount: number;
  featured?: boolean;
  hot?: boolean;
}

export default function ArticleCard({
  id,
  title,
  category,
  categoryName,
  author,
  authorAvatar,
  cover,
  excerpt,
  tags,
  createdAt,
  readCount,
  likeCount,
  commentCount,
  featured,
  hot,
}: ArticleCardProps) {
  return (
    <Link
      to={`/article/${id}`}
      className="group block bg-background-50 rounded-xl border border-background-200/70 overflow-hidden transition-all duration-300 hover:-translate-y-1 cursor-pointer"
      data-product-shop=""
    >
      <div className="aspect-[16/10] overflow-hidden relative">
        <img
          src={cover}
          alt={title}
          title={`${title} - 今日同人库`}
          className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
          loading="lazy"
        />
        <div className="absolute top-3 left-3 flex items-center gap-2">
          {featured && (
            <span className="px-2.5 py-1 bg-primary-500 text-background-50 text-xs font-medium rounded-full whitespace-nowrap">
              精选
            </span>
          )}
          {hot && (
            <span className="px-2.5 py-1 bg-accent-500 text-background-50 text-xs font-medium rounded-full whitespace-nowrap">
              热门
            </span>
          )}
        </div>
        <div className="absolute top-3 right-3">
          <span className="px-2.5 py-1 bg-foreground-950/60 text-background-50 text-xs font-medium rounded-full whitespace-nowrap">
            {categoryName}
          </span>
        </div>
      </div>

      <div className="p-4 md:p-5">
        <h3 className="text-base md:text-lg font-heading font-semibold text-foreground-950 line-clamp-2 leading-snug group-hover:text-primary-600 transition-colors">
          {title}
        </h3>

        <p className="mt-2 text-sm text-foreground-600 line-clamp-2 leading-relaxed">
          {excerpt}
        </p>

        <div className="mt-3 flex items-center flex-wrap gap-1.5">
          {tags.slice(0, 3).map((tag) => (
            <span
              key={tag}
              className="px-2 py-0.5 text-xs bg-secondary-100 text-secondary-700 rounded-md whitespace-nowrap"
            >
              {tag}
            </span>
          ))}
        </div>

        <div className="mt-4 flex items-center justify-between">
          <div className="flex items-center gap-2">
            <img
              src={authorAvatar}
              alt={author}
              className="w-7 h-7 rounded-full object-cover"
            />
            <span className="text-sm text-foreground-700 whitespace-nowrap">{author}</span>
          </div>
          <div className="flex items-center gap-3 text-xs text-foreground-500">
            <span className="flex items-center gap-1 whitespace-nowrap">
              <i className="ri-eye-line text-sm w-3.5 flex items-center justify-center"></i>
              {readCount >= 10000 ? `${(readCount / 10000).toFixed(1)}万` : readCount}
            </span>
            <span className="flex items-center gap-1 whitespace-nowrap">
              <i className="ri-heart-line text-sm w-3.5 flex items-center justify-center"></i>
              {likeCount}
            </span>
          </div>
        </div>
      </div>
    </Link>
  );
}